module.exports = __webpack_public_path__ + "static/media/ownership_correct.74913bab.png";